import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import Footer from './Footer';
import LanguageSwitcher from '../common/LanguageSwitcher';
import ScrollToTop from '../common/ScrollToTop';
import SEO from '../common/SEO';

const Layout = ({ children }) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title={t('seo.defaultTitle')} 
        description={t('seo.defaultDescription')}
      />
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <LanguageSwitcher />
      <ScrollToTop />
    </div>
  );
};

export default Layout;